import React from 'react';
import Row from './row';
import './Table.css';

function Table({ headers, rowsClass = '', cellClass='', cellClass2='', cellClass2ConditionList={}, rows, columnWidths, idViewing, idArrayId, onRowClick = ''}) {
  return (
    <div className="table">
      {/* Nagłówki */}
      <div className="table-header">
        <Row columns={headers} columnWidths={columnWidths} idViewing={idViewing} idArrayId={idArrayId} />
      </div>
      {/* Wiersze */}
      <div className="table-body">
        {rows.map((row, index) => (
          <Row
              key={index}
              columns={row.slice(0, headers.length)}
              rowClass={rowsClass}
              cellClass={cellClass}
              cellClass2={cellClass2}
              cellClass2ConditionList={cellClass2ConditionList}
              columnWidths={columnWidths}
              idViewing={idViewing}
              idArrayId={idArrayId}
              onClick={typeof onRowClick === 'function' ? () => onRowClick(row, index) : undefined}/>
        ))}
      </div>
    </div>  
  );
}

export default Table;